import React from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import RefreshButton from 'shared/ui/RefreshButton';
import { newGetVulns } from 'store/Manage/filterActions';
import { getVulnsGeneral } from 'store/ManageGeneral/actions';
import { getVulns } from 'store/Contextualization/AssetDetail/actions';
import { selectCurrentHost } from 'store/Host/selectors';
import { refreshExploreGroupHosts, refreshExploreGroupServices } from 'store/GroupVulns/actions';

const ManageRefreshButton = ({ entity }) => {
  const dispatch = useDispatch();

  const currentAsset = useSelector(selectCurrentHost);
  const hostIp = get(currentAsset, 'ip', '');

  const refresh = {
    vulns: () => dispatch(newGetVulns()),
    vulnsAssets: () => dispatch(getVulns(hostIp)),
    vulnsGeneral: () => dispatch(getVulnsGeneral())
  };

  const handleRefresh = () => {
    if (refresh[entity]) refresh[entity]();
    dispatch(refreshExploreGroupHosts());
    dispatch(refreshExploreGroupServices());
  };

  return (
    <RefreshButton onClick={ handleRefresh } />
  );
};

export default ManageRefreshButton;
